{
  "modal": {
    "buttonLabel": "नया समय चुनें",
    "text": "किसी और ने अभी-अभी वह समय बुक कर लिया है।",
    "title": "बस छूट गया!"
  },
  "nextLabel": "$t(common:next): <b>अपॉइंटमेंट समय आरक्षित करें</b>",
  "nextWeek": "अगले सप्ताह",
  "noTimeText": "चयनित तिथि के लिए कोई समय उपलब्ध नहीं है।",
  "prevWeek": "पिछला सप्ताह",
  "title": "अपना अपॉइंटमेंट समय चुनें"
}
